import { ReviewDataResponse } from "../../../../../../../api/types";
import StarDisplay from "../../../../../../../components/StarDisplay";
import useUserInfo from "../../../../../../../hooks/useUserInfo";
import { handleLastConnection } from "../../../../../../../utils/date";
import { usePubContext } from "../../../../hooks/pub-context";
import {
  PremiumPubReviewItemContentWrapper,
  PremiumPubReviewItemImage,
  PremiumPubReviewItemImageWrapper,
  PremiumPubReviewItemWrapper,
  PremiumPubReviewUserInfo,
  PremiumPubReviewUserInfoTop,
  PremiumPubReviewUserInfoUser,
  PremiumPubReviewUserInfoWrapper,
} from "./style";

interface PremiumPubReviewItemProps {
  item: ReviewDataResponse;
  setImageList: (v: string[]) => void;
  setSelectedImageIndex: (v: number) => void;
}

const PremiumPubReviewItem = ({
  item,
  setImageList,
  setSelectedImageIndex,
}: PremiumPubReviewItemProps) => {
  const { setEditReview, setShowWrite } = usePubContext();
  const { user } = useUserInfo();
  const profil = item.userProfile
    ? item.userProfile
    : "https://dfesoodpx4jgd.cloudfront.net/user/default_profile.png";

  return (
    <PremiumPubReviewItemWrapper>
      <PremiumPubReviewUserInfoWrapper>
        <img src={profil} alt="profile" />
        <PremiumPubReviewUserInfo>
          <PremiumPubReviewUserInfoTop>
            <PremiumPubReviewUserInfoUser>
              <div className="name">{item.userName}</div>
              <div className="time">{handleLastConnection(item.createdAt)}</div>
            </PremiumPubReviewUserInfoUser>
            {user?.nickname === item.userName && (
              <div
                className="edit"
                onClick={() => {
                  setEditReview(item);
                  setShowWrite(true);
                }}
              >
                편집
              </div>
            )}
          </PremiumPubReviewUserInfoTop>
          <div className="count">
            <StarDisplay rating={item.score} />
          </div>
        </PremiumPubReviewUserInfo>
      </PremiumPubReviewUserInfoWrapper>
      <PremiumPubReviewItemContentWrapper>
        {item.message}
      </PremiumPubReviewItemContentWrapper>
      <PremiumPubReviewItemImageWrapper>
        {item.imageList.slice(0, 4).map((image, i) => (
          <PremiumPubReviewItemImage
            key={i}
            onClick={() => {
              setImageList(item.imageList);
              setSelectedImageIndex(i);
            }}
          >
            <img src={image} alt={`image_${i}`} />
            {i === 3 && (
              <div
                onClick={() => {
                  setSelectedImageIndex(3);
                  setImageList(item.imageList);
                }}
                className="overlay"
              >
                더보기 ..
              </div>
            )}
          </PremiumPubReviewItemImage>
        ))}
      </PremiumPubReviewItemImageWrapper>
    </PremiumPubReviewItemWrapper>
  );
};

export default PremiumPubReviewItem;
